import { MetaErrorCodes, type Meta } from '@cplug/frontend-core/models'
import type { Address } from '../models/Address'

export function useValidateAddress (address: Address): Meta | undefined {
  let metaError = {}

  if ((address.zipcode?.trim().length ?? 0) <= 0) {
    metaError = { ...metaError, zipcode: MetaErrorCodes.Empty }
  }

  if ((address.zipcode?.trim().length ?? 0) > 0 && !useIsValidZipcode(address.zipcode ?? '')) {
    metaError = { ...metaError, zipcode: MetaErrorCodes.WrongFormat }
  }

  if (address.city == null) {
    metaError = { ...metaError, city: MetaErrorCodes.Empty }
  }

  if ((address.neighborhood?.trim().length ?? 0) <= 0) {
    metaError = { ...metaError, neighborhood: MetaErrorCodes.Empty }
  }

  if ((address.number?.trim().length ?? 0) <= 0) {
    metaError = { ...metaError, number: MetaErrorCodes.Empty }
  }

  if ((address.street?.trim().length ?? 0) <= 0) {
    metaError = { ...metaError, street: MetaErrorCodes.Empty }
  }

  return Object.keys(metaError).length > 0 ? metaError : undefined
}

export function useIsValidZipcode (zipcode: string): boolean {
  const cleanedZipcode = zipcode.replace(/\D/g, '')
  const cepRegex = /^[0-9]{8}$/
  return cepRegex.test(cleanedZipcode)
}
